import styled from "styled-components";

export const Container = styled.div`

`;

export const Content = styled.div`
	max-width: 1200px;

	margin: 0 auto;

	display: flex;
	align-items: center;
	justify-content: center;

	flex-direction: column;

	padding: 52px 0 12%;

	>h3{
		font-size: 15px;
		font-weight: 500;
		color: #B6B6B6;
	}

	>h1{
		font-size: 30px;
		font-weight: bold;

		margin: 6px 0 40px;
	}

	@media(max-width: 767px){
		>h3{
			font-size: 17px;
		}

		>h1{
			font-size: 26px;
		}
	}

	@media(min-width: 1441px){
		padding: 64px 0 12%;

		>h3{
			font-size: 16px;
		}

		>h1{
			font-size: 34px;
		}
	}
`;

export const ProposalsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	flex-direction: column;

	& + div{
		margin-top: 32px;
	}
`;

export const PropertyInformationsContainer = styled.div`
	width: 890px;

	display: flex;
	align-items: center;
	justify-content: flex-start;

	background: #F9F9F9;

	padding: 24px 32px;

	>img{
		width: 135px;
		height: 97.5px;
	}

	& + div{
		margin-top: 24px;
	}

	@media(max-width: 767px){
		width: 310px;

		align-items: flex-start;

		padding: 24px;

		>img{
			width: 111px;
			height: 82px;
		}
	}

	@media(min-width: 1441px){
		width: 1000px;

		padding: 26px 36px;

		>img{
			width: 90px;
			height: 70px;
		}
	}
`;

export const PropertyLocalContainer = styled.div`
	margin-left: 24px;

	width: 40%;

	display: flex;
	align-items: flex-start;
	justify-content: center;

	flex-direction: column;

	>h3{
		font-size: 14px;
		font-weight: bold;
		color: #6EA5FF;

		margin-bottom: 4px;
	}

	>p{
		font-size: 11px;
        margin-top: 4px;
	}

	>div{
		display: none;
	}

    >strong{
		font-size: 11px;
    }

	@media(max-width: 767px){
		width: 60%;

		>h3{
			font-size: 15px;
		}

		>p{
			font-size: 12px;
		}

		>div{
			margin-top: 12px;
			margin-left: 0;

			display: flex;
			align-items: flex-start;
			justify-content: center;

			flex-direction: column;

			font-size: 12px;

			>a, button{
				margin-top: 24px;

				text-decoration: none;
				text-align: center;

				width: 130px;

				padding: 12px 0;

				background: #00BF33;

				font-weight: 500;
				color: #FFF;
				border:none;
				font-size: 12px;
			}
			>label.error-lbl {
				font-size: 0.6rem;
				font-weight: 500;
				margin-top: 0.25rem;
				color: #FF3838;
			}
		}
	}

	@media(min-width: 1441px){
		>h3{
			font-size: 16px;
		}

		>p{
			width: 65%;

			font-size: 12px;
		}
	}
`;

export const PricesAndLinkContainer = styled.div`
	margin-left: auto;

	display: flex;
	align-items: flex-end;
	justify-content: center;

	flex-direction: column;

	>strong{
		font-size: 11px;
		font-weight: 600;

		& + strong{
			margin-top: 8px;
		}
	}

	>a, button{
		margin-top: 14px;

		text-decoration: none;
		text-align: center;

		width: 160px;

		padding: 8px 0;

		background: #00BF33;

		font-size: 12px;
		font-weight: 500;
		color: #FFF;
		border:none;
	}
	
	>label.error-lbl {
		font-size: 0.6rem;
		font-weight: 500;
		margin-top: 0.25rem;
		color: #FF3838;
	}

	@media(max-width: 767px){
		display: none;
	}

	@media(min-width: 1441px){
		>strong{
			font-size: 13px;
		}

		>a{
			font-size: 13px;
		}
	}
`;
